import React, { useState, useRef, useEffect } from "react";
import {
  Form,
  ToggleButtonGroup,
  ToggleButton,
  Card,
  Row,
  Col,
  Table,
  Button,
  Container,
} from "react-bootstrap";
// import FloatingLabel from 'react-bootstrap/FloatingLabel';
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { medicines } from "../shared/data";

// import Moment from 'react-moment';
import moment from "moment";
function Pos() {
  const [customerType, setcustomerType] = useState("inPatient");
  const patientSearchRef = useRef();
  const mobileRef = useRef();
  const handleChange = (val) => {
    setcustomerType(val);
  };

  const [billItems, setBillItems] = useState([]);
  const itemCountRef = useRef();
  const totalTaxableRef = useRef();
  const totalTaxRef = useRef();
  const grandTotalRef = useRef();
  useEffect(() => {
    if (customerType === "inPatient") {
      patientSearchRef.current.focus();
    }
    if (customerType === "walkin") {
      mobileRef.current.focus();
    }
  }, [customerType]);

  const handleOnSelect = (item) => {
    // console.log(item);
    setBillItems([...billItems, { ...item, timestamp: Date.now() }]);
  };

  useEffect(() => {
    var itemCount = billItems.reduce((acc, o) => {
      return acc + parseFloat(o.quantity ? o.quantity : 0);
    }, 0);
    var totalTaxable = billItems.reduce((acc, o) => {
      return acc + o.taxable;
    }, 0);
    var totalTax = billItems.reduce((acc, o) => {
      return acc + o.gstAmount;
    }, 0);
    var grandTotal = billItems.reduce((acc, o) => {
      return acc + o.subtotal;
    }, 0);
    //console.log(totalTaxRef);
    itemCountRef.current.innerHTML = itemCount;
    totalTaxableRef.current.innerHTML = totalTaxable;
    totalTaxRef.current.innerHTML = totalTax;
    grandTotalRef.current.innerHTML = grandTotal;
  }, [billItems]);

  const handleItemChange = ({ target }) => {
    var eleName = target.name;
    var eleValue = target.value;
    if (isNaN(eleValue)) {
      return false;
    }
    var parentTr = target.parentNode;
    while (parentTr && parentTr.tagName !== "TR") {
      parentTr = parentTr.parentNode;
    }
    var itemId = parentTr.getAttribute("data-key");
    var item = billItems.filter((billItem) => billItem.id === itemId);
    item = item[0];
    var newBillItems = billItems.filter((billItem) => billItem.id !== itemId);
    item = { ...item, [eleName]: eleValue };
    item.taxable = item.rate * item.quantity;
    item.gstAmount = (item.taxable * item.gst) / 100;
    item.subtotalWithoutDiscount = item.taxable + item.gstAmount;
    item.discountAmount = (item.subtotalWithoutDiscount * item.discount) / 100;
    item.subtotal = item.subtotalWithoutDiscount - item.discountAmount;
    setBillItems(
      [...newBillItems, item].sort((a, b) =>
        a.timestamp > b.timestamp ? 1 : -1
      )
    );
    // if(eleName === 'quantity')
    // {
    //     // item.quantity = eleValue;
    // }
  };
  const handleItemRemove = (e, timestamp) => {
    const newBillItems = billItems.filter(
      (billItem) => billItem.timestamp !== timestamp
    );
    setBillItems(newBillItems);
  };

  return (
    <Container>
      <Form>
        <div className="d-grid gap-2">
          <ToggleButtonGroup
            type="radio"
            name="options"
            defaultValue="inPatient"
            onChange={handleChange}
            className="my-3"
            size="lg"
          >
            <ToggleButton
              id="tbg-radio-1"
              value="inPatient"
              variant="outline-success"
            >
              For-Patient
            </ToggleButton>
            <ToggleButton
              id="tbg-radio-2"
              value="walkin"
              variant="outline-primary"
            >
              Walk-in Customer
            </ToggleButton>
          </ToggleButtonGroup>
        </div>
        {customerType === "inPatient" && (
          <fieldset className="mb-3">
            <legend>Search Patient</legend>
            <Form.Group className="mb-3">
              <Form.Control
                type="text"
                placeholder="KAPID0001"
                ref={patientSearchRef}
              />
            </Form.Group>
            <Card className="mb-3">
              <Card.Header as="h5">Patient info</Card.Header>
              <Card.Body>
                <p>Patient Demografic info goes here</p>
              </Card.Body>
            </Card>
          </fieldset>
        )}
        {customerType === "walkin" && (
          <fieldset className="mb-3">
            <legend>Customer Detail</legend>
            <Card>
              <Card.Body>
                <Row xs={2}>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Mobile No</Form.Label>
                      <Form.Control ref={mobileRef}></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Patient Name</Form.Label>
                      <Form.Control></Form.Control>
                    </Form.Group>
                  </Col>
                  <Col>
                    <Form.Group className="mb-3">
                      <Form.Label>Doctor</Form.Label>
                      <Form.Control></Form.Control>
                    </Form.Group>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </fieldset>
        )}

        <div className="my-3">
          <ReactSearchAutocomplete
            items={medicines}
            onSelect={handleOnSelect}
            autoFocus
            // formatResult={formatResult}
            styling={{ zIndex: 4 }}
          />
        </div>

        <Table>
          <thead>
            <tr>
              <td>Product</td>
              <td>Batch</td>
              <td>Expiry Date</td>
              <td>Unit</td>
              <td>Stock</td>
              <td>Purchase Price</td>
              <td>MRP</td>
              <td>Sale Rate</td>
              <td>Qty</td>
              <td>Taxable</td>
              <td>GST%</td>
              <td>GST</td>
              <td>Discount</td>
              <td>Subtotal</td>
              <td>
                <FontAwesomeIcon icon="fa-solid fa-trash" />
              </td>
            </tr>
          </thead>
          <tbody>
            {billItems.map((item) => {
              return (
                <tr data-key={item.id} key={item.id}>
                  <td>{item.name}</td>
                  <td>{item.batch}</td>
                  <td>{moment(item.expiry).format("DD-MM-yyyy")}</td>
                  <td>
                    <Form.Select>
                      {item.unit.map((unit) => {
                        return (
                          <option value={unit.id} key={unit.id}>
                            {unit.name}
                          </option>
                        );
                      })}
                    </Form.Select>
                  </td>
                  <td>{item.stock}</td>
                  <td>{item.cost}</td>
                  <td>{item.mrp}</td>
                  <td>{item.rate}</td>
                  <td>
                    <Form.Control
                      value={item.quantity}
                      name="quantity"
                      onChange={handleItemChange}
                    />
                  </td>
                  <td>{item.taxable}</td>
                  <td>{item.gst}</td>
                  <td>{item.gstAmount}</td>
                  <td>
                    <Form.Control
                      value={item.discount}
                      name="discount"
                      onChange={handleItemChange}
                    />
                  </td>
                  <td>{item.subtotal}</td>
                  <td>
                    <Button
                      size="sm"
                      onClick={(e) => handleItemRemove(e, item.timestamp)}
                    >
                      <FontAwesomeIcon icon="fa-solid fa-trash" />
                    </Button>
                  </td>
                </tr>
              );
            })}
          </tbody>
          <tfoot>
            <tr>
              <td colSpan={8} className="text-right">
                Total
              </td>
              <td>
                <span ref={itemCountRef}>0.00</span>
              </td>
              <td>
                <span ref={totalTaxableRef}>0.00</span>
              </td>
              <td></td>
              <td>
                <span ref={totalTaxRef}>0.00</span>
              </td>
              <td></td>
              <td>
                <span ref={grandTotalRef}>0.00</span>
              </td>
            </tr>
          </tfoot>
        </Table>
      </Form>
    </Container>
  );
}

export default Pos;
